import { TeamType } from '@/types/filters';
import { Nullable } from '@/types/generic';
import { atom } from 'jotai';

export const teamIdAtom = atom<Nullable<number>>(null);
export const teamTypeAtom = atom<Nullable<TeamType>>(null);
